/* ============================================================
   component-header-sticky-fix.js

   On product pages we hide the announcement bar via CSS
   (visibility: hidden, height: 0). That leaves the header
   element near the very top of the viewport, which causes a
   race between the IntersectionObserver in the sticky-header
   custom element and the scroll handler — sometimes the
   .shopify-section-header-sticky class never gets added when
   the user scrolls, so the menu bar stays transparent.

   Belt-and-braces fix: maintain a body.scrolled class purely
   from scrollY, which our CSS pairs with a rule that turns the
   header white on .template-product.scrolled. This runs
   independently of the existing sticky-header logic so the
   normal hide/reveal behavior continues to work.
   ============================================================ */
(function () {
  'use strict';

  if (!document.body || !document.body.classList) return;

  function update() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (y > 1) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  }

  // Run once on load to set the initial state.
  update();

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();
